import {
  ClientMenuItemsControllerGetAllMenuItemsApiArg,
  ClientMenuItemsControllerGetMenuItemByIdApiArg,
  ClientMenuItemsControllerGetAllMenuItemsApiResponse,
  ClientMenuItemsControllerGetMenuItemByIdApiResponse,
} from '@/app/store/api/restApi';
import { emptyApi } from '@/app/store/api/emptyApi';

export const menuItemApi = emptyApi.injectEndpoints({
  endpoints: (build) => ({
    getMenuItems: build.query<
      ClientMenuItemsControllerGetAllMenuItemsApiResponse,
      ClientMenuItemsControllerGetAllMenuItemsApiArg
    >({
      query: ({ locationId }) => ({
        url: 'menu-items',
        params: { locationId },
      }),
      providesTags: ['MenuItems'],
    }),

    getMenuItem: build.query<
      ClientMenuItemsControllerGetMenuItemByIdApiResponse,
      ClientMenuItemsControllerGetMenuItemByIdApiArg
    >({
      query: ({ id, locationId }) => ({
        url: `menu-items/${id}`,
        params: { locationId },
      }),
      providesTags: ['MenuItems'],
    }),
  }),
});

export const { useGetMenuItemsQuery, useLazyGetMenuItemQuery } = menuItemApi;
